import shappyInfoImport from './shappyInfo'

export const shappyInfo = shappyInfoImport
